import {Inject, Injectable} from "@angular/core";
import {Meta, MetaDefinition, Title} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class HeadServiceService {

    constructor(private _metaService: Meta, private _titleService: Title, @Inject('BASE_URL') private baseUrl: string) {
    // set to defaults
    this.setTitle(null);
    this.setDescription(null);
  }

  private titleSuffix: string = null;
  // Base functionaity

  public addTag(tag: MetaDefinition, forceCreation?: boolean): HTMLMetaElement | null {
    return this._metaService.addTag(tag, forceCreation);
  }

  public addTags(tags: MetaDefinition[], forceCreation?: boolean): HTMLMetaElement[] {
    return this._metaService.addTags(tags, forceCreation);
  }

  public getTag(attrSelector: string): HTMLMetaElement | null {
    return this._metaService.getTag(attrSelector);
  }

  public getTags(attrSelector: string): HTMLMetaElement[] {
    return this._metaService.getTags(attrSelector);
  }

  public updateTag(tag: MetaDefinition, selector?: string): HTMLMetaElement | null {
    return this._metaService.updateTag(tag, selector);
  }

  public removeTag(attrSelector: string): void {
    this._metaService.removeTag(attrSelector);
  }

  public removeTagElement(meta: HTMLMetaElement): void {
    this._metaService.removeTagElement(meta);
  }

  public getTitle(): string {
    return this._titleService.getTitle();
  }

  // Techion specific

  /**
   * Set the description of the page
   * @param description Page description
   */
  public setDescription(description: string): void {
    if (!description || description == "") {
      description = "FECPAK is the world-leading particle flotation and imaging technology that is revolutionising disease management";
    }

    this.updateTag({ "name": "description", "content": description });
    this.updateTag({ "property": "og:description", "content": description });
  }

  public setTitle(newTitle: string): void {
    this.titleSuffix = this.portalTitle + " : Submissions and test data";

    this._titleService.setTitle(`${this.titleSuffix}${newTitle ? ' : ' + newTitle : ''}`);

    var fullTitle = this.getTitle();
    // set site name
    this.updateTag({ "property": "og:site_name", "content": fullTitle });
    this.updateTag({ "property": "og:title", "content": fullTitle });
  }

    public portalTitle: string = "RATA";

  public updateTitle(title) {
    if (title) {
      this.portalTitle = title.replace(/<[^>]*>?/gm, '');
      this.setTitle("");
    }
  }
}
